// 四个清单
const fourList = {
  state: {
    topData: {},
    rowData: {},
    inspectionEntityStatus: '',
    batchList: {}
  },
  mutations: {
    // 设置头部信息
    setTopData(state, val) {
      state.topData = val
    },
    // 设置行数据信息
    setRowData(state, val) {
      state.rowData = val
    },
    // 设置巡视状态
    setInspectionEntityStatus(state, val) {
      state.inspectionEntityStatus = val
    },
    // 设置审签单数据
    setBatchList(state, val) {
      state.batchList = val
    },
  }
};
export default fourList;


// WEBPACK FOOTER //
// ./src/store/modules/fourList.js